import React, { useState } from 'react';
import useStore from '../store/useStore';

const LanguageSelector = () => {
  const { currentLanguage, availableLanguages, setLanguage } = useStore();
  const [isOpen, setIsOpen] = useState(false);

  const currentLang = availableLanguages.find(lang => lang.code === currentLanguage);

  const handleLanguageChange = (languageCode) => {
    setLanguage(languageCode);
    setIsOpen(false);
  };

  return (
    <div className="relative inline-block">
      <button
        className="flex items-center gap-2 px-3 py-2 bg-white border-2 border-namdhari-green rounded-lg cursor-pointer text-sm text-namdhari-green transition-all duration-200 hover:bg-gray-100"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Select Language"
      >
        <span className="text-base">🌐</span>
        <span className="font-medium whitespace-nowrap">
          {currentLang?.nativeName} ▼
        </span>
      </button>

      {isOpen && (
        <div className="absolute top-full right-0 bg-white border-2 border-namdhari-green rounded-lg shadow-medium z-[999] min-w-[200px] max-h-[300px] overflow-y-auto mt-1">
          <div className="px-4 py-3 bg-namdhari-green text-white font-bold text-xs uppercase tracking-wide">
            Language Selection
          </div>
          {availableLanguages.map((language) => (
            <button
              key={language.code}
              className={`flex flex-col items-start gap-0.5 w-full px-4 py-3 border-none cursor-pointer text-left transition-colors duration-200 border-b border-gray-200 last:border-b-0 hover:bg-gray-100 ${
                language.code === currentLanguage
                  ? 'bg-namdhari-cream text-namdhari-green font-medium'
                  : 'bg-white'
              }`}
              onClick={() => handleLanguageChange(language.code)}
            >
              <span className="text-sm font-medium">{language.nativeName}</span>
              <span className={`text-xs ${language.code === currentLanguage ? 'text-namdhari-green' : 'text-gray-600'}`}>
                ({language.name})
              </span>
            </button>
          ))}
        </div>
      )}

      {isOpen && (
        <div
          className="fixed inset-0 z-[998]"
          onClick={() => setIsOpen(false)}
        />
      )}
    </div>
  );
};

export default LanguageSelector;